<template>
  <div>
    <b-nav tabs class="mb-3">
        <b-nav-item v-for="item in data.meetingRooms" :key="item.id"
            :active="item.id == selectedMeetingRoomId" @click="selectedMeetingRoomId = item.id">{{ item.name }}</b-nav-item>
    </b-nav>

    <b-row class="align-items-center mb-3">
        <b-col cols="12" md="auto" class="mb-2 mb-md-0">
            <b-button-group>
                <b-button variant="outline-info" :disabled="loading" @click="changeDate(new Date(refDate.getTime() - 604800000))">
                    <i class="fa fa-chevron-left"></i> Semana Anterior
                </b-button>
                <b-button variant="outline-info" :disabled="loading" @click="changeDate(new Date())">Hoje</b-button>
                <b-button variant="outline-info" :disabled="loading" @click="changeDate(new Date(refDate.getTime() + 604800000))">
                    Próxima Semana <i class="fa fa-chevron-right"></i>
                </b-button>
            </b-button-group>
        </b-col>
        <b-col cols="12" md="auto" class="mb-2 mb-md-0 d-flex align-items-center">
            <span class="font-weight-bold">{{ $utils.dateStringFormat(startDate) }} ~ {{ $utils.dateStringFormat(endDate) }}</span>
            <button
                type="button"
                class="btn btn-link p-0 ml-2"
                :disabled="loading"
                aria-label="Atualizar agenda"
                title="Atualizar agenda"
                @click="refreshData()"
            >
                <i class="icon-refresh icons font-xl" :class="{ 'agenda-spin': loading }"></i>
            </button>
        </b-col>
        <b-col cols="12" md class="d-flex justify-content-md-end">
            <b-form-datepicker
                v-model="calendarDate"
                size="sm"
                :date-format="'yyyy-MM-dd'"
                :value="refDate"
                @input="onCalendarChange"
                style="max-width: 160px;"
            ></b-form-datepicker>
        </b-col>
    </b-row>

    <div
      class="d-flex justify-content-between agenda-scroll"
      style="max-width: 100vw; max-height: 80vh; overflow: auto;"
    >
      <agenda-date-component
        v-for="item in items"
        :item="item"
        :meeting-rooms="data.meetingRooms"
        :meeting-room-adm="data.meetingRoomAdm"
        :is-today="item.date === todayStr"
        :key="item.id"
        class="flex-shrink-0"
        style="min-width: 250px;"
        @meetingResponse="handleMeetingResponse"
      ></agenda-date-component>
    </div>

    <b-modal v-model="showCalendar" title="Escolha uma data" hide-footer>
      <b-form-datepicker
        v-model="calendarDate"
        :date-format="'yyyy-MM-dd'"
        @input="onCalendarChange"
      ></b-form-datepicker>
    </b-modal>

  </div>
</template>
<script>
import AgendaDateComponent from '../components/AgendaDateComponent.vue';

import Vue from 'vue'
import axios from "axios";
import { BFormDatepicker, BModal } from 'bootstrap-vue';

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
    name: 'AgendaComponent',
    components: {
        AgendaDateComponent,
        BFormDatepicker,
        BModal
    },
    data: function() {
        return {
            intervalId: null,
            refDate: new Date(),
            startDate: "",
            endDate: "",
            showCalendar: false,
            calendarDate: null,

            selectedMeetingRoomId: 1,

            data: {
                meetingRooms: [],
                items: [
                ]
            },
            items: [],
            loading: false
        }
    },
    computed: {
        todayStr() {
            const pad = n => n.toString().padStart(2, '0');
            const d = new Date();
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        }
    },
    methods: {
        fillWeekItems() {
            //console.log("Meeting room: ", this.selectedMeetingRoomId);
            // Helper to format date as yyyy-MM-dd
            const pad = n => n.toString().padStart(2, '0');
            const format = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            // Helper to get weekday name in Portuguese
            const weekdays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

            // Parse start and end dates
            const start = new Date(this.startDate);
            start.setHours(start.getHours() + 6);
            const end = new Date(this.endDate);
            end.setHours(end.getHours() + 6);

            // Filter items for the selected meeting room (items pode vir nulo quando não há reservas no período)
            const roomItems = (this.data.items || []).filter(
                item => item.meetingRoomId === this.selectedMeetingRoomId
            );

            // Build the week items array
            const weekItems = [];
            for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                const dateStr = format(d);
                // Try to find an item for this date
                let found = roomItems.find(item => item.date === dateStr);
                if (found) {
                    weekItems.push(found);
                } else {
                    // If not found, create a blank item for this date
                    weekItems.push({
                        id: dateStr,
                        meetingRoomId: this.selectedMeetingRoomId,
                        title: '', // or you can format as you wish
                        date: dateStr,
                        weekday: weekdays[d.getDay()],
                        meetings: []
                    });
                }
            }
            this.items = weekItems;
        },
        changeDate(newRefDate) {
            if (this.refDate && (this.refDate instanceof Date)) {
                this.refDate = newRefDate
            }
            const ref = this.refDate;            
            const prevSunday = new Date(ref);
            prevSunday.setDate(ref.getDate() - ref.getDay());
            
            const nextSaturday = new Date(ref);
            nextSaturday.setDate(ref.getDate() + (6 - ref.getDay()));
            
            const pad = n => n.toString().padStart(2, '0');
            const format = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            this.startDate = format(prevSunday);
            this.endDate = format(nextSaturday);
            this.calendarDate = this.formatDateForPicker(this.refDate);

            //console.log(this.data)
            
        },
        onCalendarChange(dateString) {
            // dateString is in 'yyyy-MM-dd'
            if (dateString) {
                const d = new Date(dateString + 'T00:00:00');
                this.changeDate(d);
                this.showCalendar = false;
            }
        },
        formatDateForPicker(dateObj) {
            const pad = n => n.toString().padStart(2, '0');
            return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())}`;
        },
        async refreshData() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            if (!currentUser || !currentUser.id) {
                // Sessão do usuário ainda não carregada (ex.: recarregamento da página);
                // aguarda o watcher de currentUser disparar a busca quando ela estiver pronta.
                return;
            }
            this.loading = true;
            await axios.get(
                this.$store.state.ws_url + "/meetingroom/reservations?startDate=" + this.refDate.toISOString().slice(0, 10) + "&companyId=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                if (!resp.data.ok || !resp.data.obj || !resp.data.obj.meetingRooms) {
                    miniToastr.warn(resp.data.message || "Não foi possível carregar a agenda de salas.", "Aviso");
                    return;
                }
                s.data = resp.data.obj;
                s.fillWeekItems();
            }).catch(function(error) {
                console.log(error)
                miniToastr.error("Erro ao carregar a agenda de salas.", "Erro");
            }).finally(function() {
                s.loading = false;
            })
        },
        handleMeetingResponse() {
            this.refreshData();
        },
    },
    watch: {
        selectedMeetingRoomId: 'fillWeekItems',
        startDate: 'fillWeekItems',
        endDate: 'fillWeekItems',
        '$store.state.currentUser'(user) {
            // Cobre o caso em que a tela monta antes da sessão do usuário ser restaurada (ex.: F5 na própria tela)
            if (user && user.id && this.data.meetingRooms.length === 0) {
                this.refreshData();
            }
        },
    },
    mounted() {        
        this.changeDate(new Date());
        this.calendarDate = this.formatDateForPicker(this.refDate);
        //this.fillWeekItems();
        this.refreshData();

        if(!this.intervalId) {
            this.intervalId = setInterval(this.refreshData, 5*60*1000); // Default to 5 minutes
        }   
    },
    beforeDestroy: function() {
        clearInterval(this.intervalId)
    }
}
</script>


<style scoped>
.agenda-scroll {
  overflow-x: auto;
  overflow-y: auto;
  max-width: 100vw;
  max-height: 80vh;
  /* Cor do scroll: ver regra global em src/assets/scss/_custom.scss */
}
.agenda-spin {
  animation: agenda-spin 1s linear infinite;
}
@keyframes agenda-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>